/* XGuidance premium pages — particles, 3D tilt, gold ray, scroll reveal */
(function () {
  'use strict';
  var root = document.documentElement;
  if (!root.classList.contains('xgp')) return;
  root.classList.add('xgp-js');
  var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var RM = mq('(prefers-reduced-motion: reduce)'), FINE = mq('(hover: hover) and (pointer: fine)');
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var TILT = '.product-item .card, .spotlight-item .image-zoom, .list-categories .collection-list-item, .productView-image-wrapper';
  var RAY = '.product-item .card-media, .spotlight-item .image-zoom, .productView-image-wrapper, .list-categories .collection-list-item .image';
  var REVEAL = '.product-item, .spotlight-item, .list-categories .collection-list-item, .productView-product, .cart-item, .wishlist-row';
  var io = ('IntersectionObserver' in window && !RM && root.classList.contains('xgp-reveal')) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' }) : null;

  function tilt(el) {
    if (el.__xgp || !FINE || RM || root.classList.contains('xgp-c--none')) return; el.__xgp = 1;
    var gentle = el.classList.contains('productView-image-wrapper'), soft = el.classList.contains('collection-list-item'), max = gentle ? 4 : soft ? 6 : 11, busy = 0, ev;
    el.classList.add('xgp-tiltbox');
    el.addEventListener('pointermove', function (e) {
      ev = e; if (busy) return; busy = 1;
      requestAnimationFrame(function () {
        busy = 0; var r = el.getBoundingClientRect(), x = (ev.clientX - r.left) / r.width, y = (ev.clientY - r.top) / r.height;
        el.style.transition = 'transform .12s linear';
        el.style.transform = 'perspective(1000px) rotateX(' + ((0.5 - y) * max).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * max * 1.15).toFixed(2) + 'deg)' + (gentle ? '' : soft ? ' translate3d(0,-4px,0)' : ' translate3d(0,-6px,0)');
      });
    });
    el.addEventListener('pointerleave', function () { el.style.transition = 'transform .9s cubic-bezier(.2,.8,.2,1)'; el.style.transform = ''; });
  }
  // Reads (layout/style) are batched before writes so a page with many cards triggers one layout, not one per card.
  function enhance(ctx) {
    $$(TILT, ctx).forEach(tilt);
    if (root.classList.contains('xgp-sun')) {
      var rays = $$(RAY, ctx).filter(function (m) { return !m.querySelector(':scope > span.xgp-ray'); });
      var isStatic = rays.map(function (m) { return getComputedStyle(m).position === 'static'; });
      rays.forEach(function (m, i) {
        if (isStatic[i]) m.style.position = 'relative';
        var s = document.createElement('span'); s.className = 'xgp-ray'; s.setAttribute('aria-hidden', 'true'); m.appendChild(s);
      });
    }
    if (io) {
      var els = $$(REVEAL, ctx).filter(function (el) { if (el.__xgpR) return false; el.__xgpR = 1; return true; });
      var vh = window.innerHeight;
      var hidden = els.map(function (el) { var r = el.getBoundingClientRect(); return !(r.top < vh && r.bottom > 0); }); // already visible: no flash
      els.forEach(function (el, i) {
        if (!hidden[i]) return;
        el.classList.add('xgp-rv'); el.style.setProperty('--xgp-i', i % 4); io.observe(el);
      });
    }
  }

  function particles() {
    if (RM || !root.classList.contains('xgp-parts') || navigator.connection && navigator.connection.saveData) return;
    var cv = document.createElement('canvas'); cv.className = 'xgp-canvas'; cv.setAttribute('aria-hidden', 'true'); document.body.appendChild(cv);
    var ctx = cv.getContext('2d'), W, H, ps = [], small = mq('(max-width: 749px)'), N = small ? 28 : 55, last = 0, on = true;
    var C = ['255,241,184', '21,242,252', '0,255,136', '187,48,254', '255,255,255'];
    function size() { W = cv.width = window.innerWidth; H = cv.height = window.innerHeight; }
    size(); window.addEventListener('resize', size);
    for (var i = 0; i < N; i++) ps.push({ x: Math.random() * W, y: Math.random() * H, vx: (Math.random() - 0.5) * 0.15, vy: -0.05 - Math.random() * 0.2, r: 0.6 + Math.random() * 1.8, c: C[(Math.random() * 5) | 0], p: Math.random() * 6.28 });
    function draw(ts) {
      if (!on) return; requestAnimationFrame(draw);
      if (ts - last < 40) return; last = ts;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < N; i++) {
        var p = ps[i]; p.x += p.vx; p.y += p.vy; p.p += 0.03;
        if (p.y < -10) { p.y = H + 10; p.x = Math.random() * W; } if (p.x < -10) p.x = W + 10; if (p.x > W + 10) p.x = -10;
        var a = 0.35 + Math.sin(p.p) * 0.3;
        ctx.fillStyle = 'rgba(' + p.c + ',' + a.toFixed(2) + ')'; ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
        if (p.r > 2) { ctx.fillStyle = 'rgba(' + p.c + ',' + (a * 0.25).toFixed(2) + ')'; ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 3.5, 0, 6.283); ctx.fill(); }
      }
    }
    requestAnimationFrame(draw);
    document.addEventListener('visibilitychange', function () { on = !document.hidden; if (on) requestAnimationFrame(draw); });
  }

  function boot() {
    enhance(document);
    // particles start once the page has loaded, so they never compete with the first paint
    var startParts = function () { setTimeout(particles, mq('(max-width: 749px)') ? 1500 : 300); };
    if (document.readyState === 'complete') startParts(); else window.addEventListener('load', startParts, { once: true });
    if ('MutationObserver' in window) {
      var t = 0;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { enhance(document); }, 150); })
        .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
